module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_100_250.cefdc376.png";